<mat-form-field
        [ngClass]="{'outline': outlined}"
        [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
        [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
        class="app-select"
>
    <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

    <mat-select
        #select
        panelClass="app-select-panel"
        disableOptionCentering
        [placeholder]="asFormsControl().placeholder"
        [disabled]="asFormsControl().disabled"
        [multiple]="asFormsControl().multiple"
        (selectionChange)="changeValue($event)"
        (openedChange)="onTouched && onTouched()"
    >
        <mat-option
                *ngFor="let option of asFormsControl().options"
                [value]="option.value"
                [disabled]="option.disabled"
        >
            {{option.label}}
        </mat-option>
    </mat-select>

</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
